import { Activity, Result, Funnel, Host, UserAction, User } from './officeeventschema.tml';
import { Error } from './Office.System.Error';

import _Activity = Activity;
import _Result = Result;
import _Error = Error;
import _Funnel = Funnel;
import _Host = Host;
import _UserAction = UserAction;
import _User = User;

export namespace Contracts {
  export namespace Office {
    export namespace System {
      export import Activity = _Activity;
      export import Result = _Result;
      export import Error = _Error;
      export import Funnel = _Funnel;
      export import Host = _Host;
      export import User = _User;
      export import UserAction = _UserAction;
    }
  }
}
